// TODO HCPF-2011: fill in RESOURCE_SERVICES with corresponding category title, actions, and
// columnRoleIds. Resource level work to be tackled in phase 4 https://hashicorp.atlassian.net/browse/HCPF-2011.

const roleDefinitionFlyoutTranslationPath =
  'manage-access.components.flyout.role-definitions-flyout.resource';

export const RESOURCE_SERVICES = [
  {
    id: 'basic',
    title: `${roleDefinitionFlyoutTranslationPath}.some-title-here`,
    categories: [
      {
        title: `${roleDefinitionFlyoutTranslationPath}.service-name.categories.category-name.category-title`,
        actions: [
          {
            title: `${roleDefinitionFlyoutTranslationPath}.service-name.categories.category-name.category-title`,
            permissions: ['resource-manager.projects.list'],
          },
        ],
        columnRoleIds: ['roles/some-role-id'],
      },
    ],
  },
];
